import{createAction}from'@reduxjs/toolkit';export const loggedOut=createAction('auth/loggedOut');